import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

type NeedRedeemData = {
  modifyId: string;
  fulfillId: string;
  imageList: Image[];
  modifiedList: Image[];
  context: string;
  redeemData: ImageWithText[];
};
const initialState: NeedRedeemData = {
  modifyId: "",
  fulfillId: "",
  imageList: [],
  modifiedList: [],
  context: "",
  redeemData: [],
};

const redeemSlice = createSlice({
  name: "redeem",
  initialState,
  reducers: {
    setRedeemData: (state: NeedRedeemData, action: PayloadAction<{ redeemData: ImageWithText[] }>) => ({
      ...state,
      ...{
        redeemData: action.payload.redeemData ?? state.redeemData,
      },
    }),
    setRedeemImageList: (state: NeedRedeemData, action: PayloadAction<{ imageList: Image[] }>) => ({
      ...state,
      ...{
        imageList: action.payload.imageList ?? state.imageList,
      },
    }),
    setFulFillId: (state: NeedRedeemData, action: PayloadAction<{ fulfillId: string }>) => ({
      ...state,
      ...{
        fulfillId: action.payload.fulfillId ?? state.fulfillId,
      },
    }),
    setRedeemDataAllInit: (NeedRedeemData) => initialState,
    setRedeemDataInit: (state: NeedRedeemData) => ({ ...state, redeemData: [] }),
    setModifiedList: (state: NeedRedeemData, action: PayloadAction<{ modifiedList: Image[] }>) => ({
      ...state,
      ...{
        modifiedList: action.payload.modifiedList ?? state.modifiedList,
      },
    }),
    setContext: (state: NeedRedeemData, action: PayloadAction<{ context: string }>) => ({
      ...state,
      ...{
        context: action.payload.context ?? state.context,
      },
    }),
    setModifyId: (state: NeedRedeemData, action: PayloadAction<{ modifyId: string }>) => ({
      ...state,
      ...{
        modifyId: action.payload.modifyId ?? state.modifyId,
      },
    }),
  },
});

export const { setRedeemData, setRedeemImageList, setFulFillId, setRedeemDataAllInit, setModifiedList, setContext, setModifyId, setRedeemDataInit } =
  redeemSlice.actions;

export default redeemSlice.reducer;
